import type { GetGitConnectionsResponse } from '@eggplant/types'

export const ONLY_INTERNAL_STORAGE = 'Internal storage'
export const ONLY_GIT_CONNECTIONS = 'Git connections'
export const ALL_INTERNAL_STORAGE = 'all_internal_storage'
export const ALL_GIT = 'all_git'

interface labelValue {
  label: string
  value: string
}

export const initialOptions: labelValue[] = [
  {
    label: ONLY_INTERNAL_STORAGE,
    value: ALL_INTERNAL_STORAGE
  },
  {
    label: ONLY_GIT_CONNECTIONS,
    value: ALL_GIT
  }
]

export const defaultResponse: GetGitConnectionsResponse = {
  items: [],
  total_count: 0,
  date_as_of: ''
}

export const GIT_REFERENCE = 'git_ref'